import { render, staticRenderFns } from "./DesigningPlans.vue?vue&type=template&id=018c5b0b&"
import script from "./DesigningPlans.vue?vue&type=script&lang=ts&"
export * from "./DesigningPlans.vue?vue&type=script&lang=ts&"
import style0 from "./DesigningPlans.vue?vue&type=style&index=0&id=018c5b0b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports